module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/Payslip.ejs -->\n<!-- header -->\n<div class="row row-header">\n    ';
 if (company.getLogoUrl()) { 
__p+='\n        <div class="col-xs-12">\n            <img class="company-logo"\n                src="'+
((__t=( company.getLogoUrl() ))==null?'':_.escape(__t))+
'" />\n        </div>\n    ';
 } 
__p+='\n    <div class="col-sm-4 m-b-md">\n        <div class="title">Payslip</div>\n        <strong>'+
((__t=( model.getPeriodFormatted() ))==null?'':_.escape(__t))+
'</strong>\n        <div>Issue Date: '+
((__t=( formattedSubmitDate ))==null?'':_.escape(__t))+
'</div>\n    </div>\n    <div class="col-sm-4 m-b-md">\n        <div class="title">Company</div>\n        <strong>'+
((__t=( company.get('companyName') ))==null?'':_.escape(__t))+
'</strong>\n        <div>'+
((__t=( address.get('line1') ))==null?'':_.escape(__t))+
'</div>\n        <div>'+
((__t=( address.get('postcode') ))==null?'':_.escape(__t))+
' '+
((__t=( address.get('city') ))==null?'':_.escape(__t))+
'</div>\n        <div>'+
((__t=( address.getStateName() ))==null?'':_.escape(__t))+
'</div>\n    </div>\n    <div class="col-sm-4 m-b-md">\n        <div class="title">Employee</div>\n        <strong>'+
((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
'</strong>\n        <div>'+
((__t=( employee.getPositionName() ))==null?'':_.escape(__t))+
'</div>\n        <div>IC/Passport: '+
((__t=( employee.get('idStr') ))==null?'':_.escape(__t))+
'</div>\n        <div>EPF Number: '+
((__t=( employee.get('epfNumber') ))==null?'':_.escape(__t))+
'</div>\n        <div>PCB Number: '+
((__t=( employee.get('taxNumber') ))==null?'':_.escape(__t))+
'</div>\n    </div>\n</div>\n\n<!-- earnings -->\n<table class="footable footable-payslip earnings\n    footable-ellipsis table table-stripped"\n    data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th class="colored">Earnings</th>\n            <th class="text-left payslip-rate hidden-xs">Rate</th>\n            <th class="text-right payslip-amount">Current Period (RM)</th>\n        </tr>\n    </thead>\n    <tbody>\n        ';
 additions.forEach(function(detail) { 
__p+='\n            ';
 payrollItem = detail.getPayrollItem() 
__p+='\n            <tr class="tr-md">\n                <td class="name">\n                    '+
((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
'\n                    ';
 if (
                        payrollItem.get('type') === 'overtime' &&
                        overtimeFootnote
                    ) { 
__p+='\n                        <small class="footnote">5</small>\n                    ';
 } 
__p+='\n                </td>\n                <td class="text-left hidden-xs">\n                    ';
 if (detail.get('amount') && detail.isUnit()) { 
__p+='\n                        '+
((__t=( detail.get('unit') ))==null?'':_.escape(__t))+
' @ RM\n                        '+
((__t=( (detail.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    ';
 } 
__p+='\n                </td>\n                <td class="text-right">\n                    '+
((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n            </tr>\n        ';
 }) 
__p+='\n        <tr class="tr-md">\n            <td><strong>Total Earnings</strong></td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                <strong class="colored">\n                    '+
((__t=( Number(additions.getNetAmount()).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </strong>\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<!-- deductions -->\n<table class="footable footable-payslip deductions\n    footable-ellipsis table table-stripped" data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th class="colored">Deductions</th>\n            <th class="payslip-rate hidden-xs"></th>\n            <th class="payslip-amount"></th>\n        </tr>\n    </thead>\n    <tbody>\n        ';
 deductions.forEach(function(detail) { 
__p+='\n            ';
 payrollItem = detail.getPayrollItem() 
__p+='\n\n            <tr class="tr-md">\n                <td class="name">\n                    ';
 if (detail.getPayrollItemName() === 'EIS') { 
__p+='\n                        Employee EIS\n                    ';
 } else { 
__p+='\n                        '+
((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
'\n                    ';
 } 
__p+='\n                    ';
 if (
                        payrollItem.get('type') === 'mtd' &&
                        payrollItem.get('subtype') !== 'custom' &&
                        mtdFootnote
                    ) { 
__p+='\n                        <small class="footnote">1</small>\n                    ';
 } 
__p+='\n                    ';
 if (
                        payrollItem.get('type') === 'unpaid_leave' &&
                        unpaidLeaveFootnote &&
                        !detail.get('isAdditional')
                    ) { 
__p+='\n                        <small class="footnote">2</small>\n                    ';
 } 
__p+='\n                    ';
 if (
                        payrollItem.get('type') === 'epf' &&
                        epfFootnote.employeeRate > 0
                    ) { 
__p+='\n                        <small class="footnote">3</small>\n                    ';
 } 
__p+='\n                </td>\n                <td class="text-left hidden-xs">\n                    ';
 if (detail.get('amount') && detail.isUnit()) { 
__p+='\n                        '+
((__t=( detail.get('unit') ))==null?'':_.escape(__t))+
' @\n                        '+
((__t=( (detail.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    ';
 } 
__p+='\n                </td>\n                <td class="text-right">\n                    '+
((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </td>\n            </tr>\n        ';
 }) 
__p+='\n\n        <tr class="tr-md">\n            <td><strong>Total Deductions</strong></td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                <strong class="colored">\n                    '+
((__t=( Math.abs(deductions.getNetAmount()).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </strong>\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<!-- net income -->\n<table class="footable footable-payslip net-income\n    footable-ellipsis table table-stripped" data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th></th>\n            <th class="payslip-rate hidden-xs"></th>\n            <th class="payslip-amount"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr class="tr-md net">\n            <td><strong>Net Income</strong></td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                <strong>\n                    '+
((__t=( model.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </strong>\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">\n                Taxable Income\n                ';
 if (benefits.length > 0) { 
__p+='\n                    <small class="footnote">4</small>\n                ';
 } 
__p+='\n            </td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
((__t=( model.get('taxable').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<!-- contributions -->\n<table class="footable footable-payslip footable-ellipsis\n    table table-stripped m-b-xl" data-striping="false">\n    <thead>\n        <tr class="tr-md">\n            <th>Employer Contributions</th>\n            <th class="payslip-rate hidden-xs"></th>\n            <th class="payslip-amount"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr class="tr-md">\n            <td class="name">\n                EPF\n                ';
 if (epfFootnote && epfFootnote.employeeRate > 0) { 
__p+='\n                    <small class="footnote">3</small>\n                ';
 } 
__p+='\n            </td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
((__t=( model.get('employerEpf').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">Socso</td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
((__t=( model.get('employerSocso').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">EIS</td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
((__t=( (model.get('employerEis') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n            </td>\n        </tr>\n        <tr class="tr-md">\n            <td class="name">HRDF</td>\n            <td class="text-right hidden-xs"></td>\n            <td class="text-right">\n                '+
((__t=( (model.get('totalHrdf') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<div class="line-break"><hr class="m-b-sm"></div>\n\n<div>\n    ';
 if (mtdFootnote) { 
__p+='\n        <small class="footnote">1</small>\n        Tax calculations are based on Employee attributes:\n        '+
((__t=( mtdFootnote.employeeAttributes ))==null?'':_.escape(__t))+
'\n        ';
 if (taxDeductions.length > 0) { 
__p+='\n            <br>\n            List of deductible Items that do not affect\n            Gross/Net Income:\n            <ul>\n                ';
 taxDeductions.forEach(function(detail) { 
__p+='\n                    <li>\n                        '+
((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
' :\n                        RM '+
((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </li>\n                ';
 }) 
__p+='\n            </ul>\n        ';
 } 
__p+='\n    ';
 } 
__p+='\n</div>\n<div>\n    ';
 if (unpaidLeaveFootnote) { 
__p+='\n        ';
 methods = [
            false,
            'Fixed number of days',
            'All days in current calendar month',
            'Working days in current calendar month'
        ] 
__p+='\n\n        <small class="footnote">2</small>\n        Unpaid leave is calculated based on the method of\n        ';
 if (unpaidLeaveFootnote instanceof Array) { 
__p+='\n            <i>'+
((__t=( methods[_.first(unpaidLeaveFootnote).method] || 'Unknown' ))==null?'':_.escape(__t))+
'</i>:\n            <ul>\n                ';
 unpaidLeaveFootnote.forEach(function (footnote) { 
__p+='\n                    <li>\n                        '+
((__t=( footnote.itemName ))==null?'':_.escape(__t))+
': ('+
((__t=( footnote.amount.formatWithoutRounding() ))==null?'':_.escape(__t))+
' *\n                        '+
((__t=( footnote.daysTaken ))==null?'':_.escape(__t))+
' unpaid days taken) /\n                        '+
((__t=( footnote.monthDays ))==null?'':_.escape(__t))+
' days\n                    </li>\n                ';
 }) 
__p+='\n            </ul>\n        ';
 } else { 
__p+='\n            <i>'+
((__t=( methods[unpaidLeaveFootnote.method] || 'Unknown' ))==null?'':_.escape(__t))+
'</i>:\n            (('+
((__t=( unpaidLeaveFootnote.details.map(function (detail) {
                return (
                    detail.getPayrollItemName() + ': ' +
                    detail.get('amount').formatWithoutRounding()
                );
            }).join(' + ') ))==null?'':_.escape(__t))+
') * '+
((__t=( unpaidLeaveFootnote.daysTaken ))==null?'':_.escape(__t))+
' unpaid\n            leave days taken) / '+
((__t=( unpaidLeaveFootnote.monthDays ))==null?'':_.escape(__t))+
' days\n        ';
 } 
__p+='\n    ';
 } 
__p+='\n</div>\n<div>\n    ';
 if (epfFootnote && epfFootnote.employeeRate > 0) { 
__p+='\n        <small class="footnote">3</small>\n        Contributions for EPF are calculated based on\n        '+
((__t=( epfFootnote.employeeRate || 0 ))==null?'':_.escape(__t))+
'% employee rate\n        ';
 if (epfFootnote.employerRate) { 
__p+='\n            and '+
((__t=( epfFootnote.employerRate || 0 ))==null?'':_.escape(__t))+
'% employer rate\n        ';
 } else if (epfFootnote.employerContrib) { 
__p+='\n            and a fixed employer contribution of RM\n            '+
((__t=( epfFootnote.employerContrib || 0 ))==null?'':_.escape(__t))+
'\n\n            ';
 if (epfFootnote.nonResident) { 
__p+='\n                for non-resident\n            ';
 } 
__p+='\n        ';
 } 
__p+='\n        ';
 if (epfFootnote.employeeExtraDeduction || epfFootnote.employerExtraDeduction) { 
__p+='\n          <br>\n        ';
 } 
__p+='\n        ';
 if (epfFootnote.employeeExtraDeduction) { 
__p+='\n            EPF employee contribution manually reduced by RM\n            '+
((__t=( epfFootnote.employeeExtraDeduction ))==null?'':_.escape(__t))+
'\n        ';
 } 
__p+='\n        ';
 if (epfFootnote.employerExtraDeduction) { 
__p+='\n            '+
((__t=( epfFootnote.employeeExtraDeduction ? 'and' : '' ))==null?'':_.escape(__t))+
'\n            EPF employer contribution manually reduced by RM\n            '+
((__t=( epfFootnote.employerExtraDeduction ))==null?'':_.escape(__t))+
'\n        ';
 } 
__p+='\n    ';
 } 
__p+='\n</div>\n<div>\n    ';
 if (benefits.length > 0) { 
__p+='\n        <small class="footnote">4</small>\n        Taxable Income includes Perquisites/Benefits-in-Kind:\n        <ul>\n            ';
 benefits.forEach(function(detail) { 
__p+='\n                <li>\n                    '+
((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
' :\n                    RM '+
((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </li>\n            ';
 }) 
__p+='\n        </ul>\n    ';
 } 
__p+='\n    ';
 if (nonTaxables.length > 0) { 
__p+='\n        <small class="footnote">5</small>\n        Benefits-in-kind not affecting taxable income:\n        <ul>\n            ';
 nonTaxables.forEach(function(detail) { 
__p+='\n                <li>\n                    '+
((__t=( detail.getPayrollItemName() ))==null?'':_.escape(__t))+
' :\n                    RM '+
((__t=( (detail.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                </li>\n            ';
 }) 
__p+='\n        </ul>\n    ';
 } 
__p+='\n</div>\n<div>\n    ';
 if (overtimeFootnote) { 
__p+='\n        <small class="footnote">5</small>\n        Overtime was calculated using the following parameters:\n        <ul>\n            ';
 overtimeFootnote.forEach(function(detail) { 
__p+='\n                <li>\n                    '+
((__t=( detail.name ))==null?'':_.escape(__t))+
' :\n                        Hourly wage: '+
((__t=( detail.hourlyWage ))==null?'':_.escape(__t))+
',\n                        Rate: '+
((__t=( detail.factor ))==null?'':_.escape(__t))+
'x\n                </li>\n            ';
 }) 
__p+='\n        </ul>\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/Payslip.ejs
// module id = 751
// module chunks = 1